import { Box, Link } from "@mui/material";
import {
  Datagrid,
  List,
  ShowButton,
  TextField,
  FunctionField,
  RaRecord,
} from "react-admin";
import { WalletTransactionEnums } from "../../enums/WalletTransactionEnums";
import { formatDateTime } from "../../utils/DateTimeUtils";
import { getReferenceName } from "../../utils/walletTransactionReference";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
  { type: "text", label: "Reference Id", source: "referenceId" },
  {
    type: "select",
    label: "Reference Model Name",
    source: "referenceModelName",
    minWidth: 220,
    options: Object.values(WalletTransactionEnums).map((value) => ({
      value,
      label: value,
    })),
  },
];

const WalletTransactionsList = (props: any) => {
  return (
    <List
      {...props}
      sort={{ field: 'createdAt', order: 'DESC' }}
      sx={{
        "& .RaList-content": {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
      }}
    >
      <>
      <CommonFilterCard fields={filterFields} />

      <br />

      <StyledDatagridWrapper title="Wallet Transactions">
      <Datagrid bulkActionButtons={false} sx={commonDatagridSx}>
        <TextField source="id" sortable={false} />
        <TextField source="userWalletId" sortable={false} />
        <TextField source="amount" sortable={false} />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Reference Id" render={(record: RaRecord) => {
            return (
                <Link href={`/#/${getReferenceName(record?.referenceModelName)}/${record?.referenceId}/show`}>
                    {record?.referenceId}
                </Link>
                );
        }} />
        <TextField source="referenceModelName" sortable={false} />
        <FunctionField
          label="Created At"
          render={(record: any) =>
            record?.createdAt ? formatDateTime(record.createdAt) : "-"
          }
        />
        <FunctionField
          label="Updated At"
          render={(record: any) =>
            record?.updatedAt ? formatDateTime(record.updatedAt) : "-"
          }
        />
        <FunctionField
            label="Action"
            render={() => {
              return (
                <Box sx={{ display: "flex" }}>
                  <ShowButton />
                </Box>
              );
            }}
        />
      </Datagrid>
      </StyledDatagridWrapper>
      </>
    </List>
  );
};
export default WalletTransactionsList;
